import * as _ from 'lodash'; const { sortBy } = _.sortBy ? _ : _.default
import { isAnalyzable } from './Effect'


export const CONTROL_IDS = [
	'SUGeLS', /* Placebo*/
	'S0CbN', 'S2CbN', /*Control*/
	'S1CmeM', /*Study Control*/
	'S4CbN', 'S6CbN', /* Control groups*/
	'S0Gg2_', 'S1Gg2_', /* Comparator */
	'SULM9E', /* Standard of care */
	'SUC2Wo', /* No treatment */
	'SUKXN', /* Vehicle */
	'SUCq-m', /* Patient Observation */
	'SUBUCU', /* Supportive care */
	'SURXiz','SGIiv' /* No treatment */
]

export function assignGroupArms({ groups, outcome, assignmentScores, doAssignment, groupPooling, analyzableWeight, returnScores, analysisType, analyzeAsLabels, allowAdditiveInterventions }) {
	let assignedGroups = new Map()
	let assignedInterventions = new Set()
	let bestScores = sortBy(Array.from(assignmentScores || []), ([groupId, score]) =>
		score > 0 ? -score : Infinity)
	let bestScore = 0
	let comparativeGroupScore = 0.0625 // a baseline score
	let totalMatchingScore = 0.0625
	for (let group of groups) {
		if (group.score)
			group.score = null
		if (group.analyzeAs)
			group.analyzeAs = null
	}
	let cohortGroupScore = 0 // score for at least one group
	for (let [ groupInterventionId, matchingScore ] of bestScores) {
		let [ groupId, intervention ] = groupInterventionId.split('\x1E')
		let cell = outcome?.cells.find(cell => cell.group == groupId)
		let cellScore = cell && isAnalyzable(cell, outcome)
		let score = (1 - (1 - cellScore) * analyzableWeight) * matchingScore
		bestScore = Math.max(score, bestScore)
		let group = groups.find(group => group.Id == groupId)
		if (cellScore > 0.2)
			group.score = Math.max(score, group.score || 0)
		if (cellScore > 0.2 && 
				(!assignedGroups.has(groupId) || allowAdditiveInterventions && intervention != 'Control' && assignedGroups.get(groupId) != 'Control') && group &&
				!(group.ParentGroup && assignedGroups.has(group.ParentGroup)) &&
				(!assignedInterventions.has(intervention) ||
					(groupPooling && !cell.AMs && (score > bestScore / 1.25) && !group.subgroupAnalyzeAs && !group.IsSubGroup))) {
			// analyzability score for how it can be compared to at least one previous group
			if (!assignedInterventions.has(intervention)) {
				comparativeGroupScore = 1 - (1 - score * cohortGroupScore) * (1 - comparativeGroupScore)
				cohortGroupScore = 1 - (1 - score * 0.8) * (1 - cohortGroupScore)
				if (intervention != 'Control' || analysisType == 'cohort')
					totalMatchingScore = 1 - (1 - matchingScore * 0.8) * (1 - totalMatchingScore)
			}
			//if (doAssignment) {
			if (assignedGroups.has(groupId))
				group.analyzeAs += ' + ' + intervention
			else
				group.analyzeAs = intervention
			group.matchingScore = matchingScore
			//}
			assignedGroups.set(groupId, intervention)
			assignedInterventions.add(intervention)
			if (group.ParentGroup && !assignedGroups.has(group.ParentGroup)) {
				let parentGroup = groups.find(parentGroup => parentGroup.Id == (group.ParentGroup.Id || group.ParentGroup))
				if (parentGroup) {
					if (parentGroup.analyzeAs)
						continue
					parentGroup.subgroupAnalyzeAs = intervention
				}
			}
		}
	}
	if (returnScores) {
		let highestComparatorScore = 0.001
		for (let i = 0; i < analyzeAsLabels.length - 1; i++)
			highestComparatorScore = 1 - 0.2 * (1 - highestComparatorScore)
		let highestCohortScore = analysisType == 'cohort' ? 1 - 0.2 * (1 - highestComparatorScore) : highestComparatorScore
		let groupScore = analysisType == 'cohort' ? cohortGroupScore / highestCohortScore :
			analysisType == 'auto' ? comparativeGroupScore / highestComparatorScore * 0.8 + cohortGroupScore / highestCohortScore * 0.2 :
				comparativeGroupScore / highestComparatorScore
		let interventionMatchingScore = Math.min(1, (totalMatchingScore / highestCohortScore * 0.75 + groupScore * 0.25))
		groupScore = Math.min(1, groupScore * 0.75 + interventionMatchingScore * 0.25)
		return {
			interventionMatchingScore,
			groupScore,
		}

	}
}
